// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2A33L","footer":"ChangeClinic_footer___LTFx"};